// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"268":"GamePage","626":"PokedexPage"}[chunkId] + "." + {"268":"e21360c0","626":"c25a5adc"}[chunkId] + ".css";
};